import React from 'react';
import {withGlobalize, WithGlobalizeProps} from 'react-native-globalize';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import Util from 'src/Util';
import Header from '../../../elements/Header';
import RoundedButton, {ButtonType} from '../../../elements/RoundedButton';
import Styles from '../../../Styles';
import AVText from '../../../elements/AVText';
import AccountStore from 'src/stores/AccountStore';
import {StyleSheet, ScrollView, View} from 'react-native';
import {WithLocalizedProps} from 'src/types/PropTypes';

type BaseSummaryScreenProps = WithGlobalizeProps &
  WithLocalizedProps & {
    titleText: string;
  } & Partial<{
    headlineText: string;
    accessibilityLabel: string;
    returnRoute: AppRoutes;
    balance: number;
    ccDisplay: string;
    totalDue: number;
    subtotal: number;
    discount: number;
    totalAmt: string;
    taxes: Array<any>;
    deposit: number;
    items: Array<any>;
    points: number;
  }>;

class BaseSummaryScreen extends React.Component<
  React.PropsWithChildren<BaseSummaryScreenProps>
> {
  constructor(props) {
    super(props);
    this.onDonePressed = this.onDonePressed.bind(this);
  }

  onDonePressed() {
    if (this.props.returnRoute) {
      NavActions.popToRoute(this.props.returnRoute);
    } else {
      NavActions.popToTop();
    }
  }

  render() {
    let promotionText: JSX.Element | null = null;

    if (this.props.discount && this.props.discount > 0) {
      promotionText = (
        <AVText style={[styles.banner, styles.promotionText]}>
          {this.props.strings.Labels.formatString(
            this.props.strings.Labels.you_saved_paying,
            Util.formatCurrency(
              this.props,
              this.props.discount,
              AccountStore.getCurrency(),
            ),
          )}
        </AVText>
      );
    }

    let rewardText: JSX.Element | null = null;

    if (this.props.points && this.props.points > 0) {
      rewardText = (
        <AVText style={[styles.banner, styles.rewardText]}>
          {this.props.strings.Labels.formatString(
            this.props.strings.Labels.you_received_rewards,
            this.props.points,
          )}
        </AVText>
      );
    }

    return (
      <Header title={this.props.titleText}>
        <View style={styles.receipt}>
          {promotionText}
          {rewardText}
          {this.props.headlineText ? (
            <View style={styles.header}>
              <AVText style={styles.headline}>{this.props.headlineText}</AVText>
            </View>
          ) : null}
          <ScrollView style={styles.scrollView}>
            <>
              {this.props.children}
              <View style={styles.bottom} />
            </>
          </ScrollView>
        </View>
        <RoundedButton
          buttonType={ButtonType.action}
          onPress={this.onDonePressed}
          accessibilityLabel="Done"
          text={this.props.strings.Buttons.done}
        />
      </Header>
    );
  }
}

const styles = StyleSheet.create({
  banner: {
    marginBottom: Styles.Spacing.m2,
    textAlign: 'left',
  },
  bottom: {
    height: Styles.Spacing.m5 + Styles.Spacing.m1,
    width: '100%',
  },
  header: {
    alignItems: 'center',
    alignSelf: 'stretch',
    marginVertical: Styles.Spacing.m2,
  },
  headline: {
    color: Styles.black,
    fontSize: Styles.Fonts.f1,
  },
  promotionText: {
    color: Styles.primaryColor,
    fontSize: Styles.Fonts.f2,
  },
  receipt: {
    flex: 1,
    padding: Styles.Spacing.m3,
  },
  rewardText: {
    color: Styles.positiveColor,
    fontSize: Styles.Fonts.f2,
  },
  scrollView: {
    paddingBottom: Styles.Spacing.m5,
  },
});
export default withGlobalize(BaseSummaryScreen);
